import { render, staticRenderFns } from "./tord_invoice_with.vue?vue&type=template&id=11806cbf&scoped=true&"
import script from "./tord_invoice_with.vue?vue&type=script&lang=js&"
export * from "./tord_invoice_with.vue?vue&type=script&lang=js&"
import style0 from "./tord_invoice_with.vue?vue&type=style&index=0&id=11806cbf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11806cbf",
  null
  
)

export default component.exports